// extracted by mini-css-extract-plugin
module.exports = {"notification":"iXipC","whatsapp":"wT3qa"};